module.exports = __webpack_public_path__ + "img/module-thumb.59d04b99.jpg";